<template>
  <resource-box name="废旧物资回收/拆解量">
    <div class="rectangle5-content" slot="content">
      <template v-if="materials?.length">
        <el-carousel :autoplay="false" style="height: 100%; width: 100%">
          <el-carousel-item v-for="(temp, index) in reclaim" :key="index">
            <div class="carouselBox">
              <div
                v-for="(item, i) in temp"
                :key="item.type"
                class="rectangle5-content-dom"
              >
                <div class="rectangle5-content-title">
                  <div class="rectangle5-content-name" :title="item.name">
                    {{ item.name }}
                  </div>
                  <div class="rectangle5-content-unit">{{ item.unit }}</div>
                </div>
                <div class="rectangle5-content-images">
                  <img
                    class="rectangle5-content-img"
                    :src="baseUrl + item.icon"
                    alt=""
                  />
                </div>
                <div class="rectangle5-content-size">
                  {{
                    Number.isInteger(Number(item.amount))
                      ? Number(item.amount)
                      : Number(item.amount).toFixed(2)
                  }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </template>
      <el-empty
        v-else
        :image="require('@/assets/recycling/index/empty.svg')"
        description="暂无数据"
      />
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
export default {
  name: 'wasteMaterials',
  components: {
    resourceBox,
  },
  props: {
    materials: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      reclaim: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      dataType: window.localStorage.getItem('dataType') || '',
    };
  },
  watch: {
    materials: {
      handler: function (newValue) {
        let filterArray = [];
        if (newValue) {
          // 过滤网点详情资源交易量
          filterArray = newValue.filter((item) => {
            return (
              item.type !== '10218' && item.type !== '10219' && item.isShow
            );
          });
          this.reclaim = this.splitArray(filterArray, 8);
        }
      },
    },
  },
  mounted() {},
  methods: {
    splitArray(arr, chunkSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    },
  },
};
</script>

<style lang="less" scoped>
.rectangle5-content {
  width: 100%;
  height: 100%;

  .rectangle5-content-dom {
    height: 48%;
    width: 25%; /* 每行最多4个，每个占25%宽度 */
    text-align: center;
    box-sizing: border-box;
    padding: 0 8px;

    .rectangle5-content-title {
      width: 100%;
      height: 41px;
      text-align: center;
      margin-bottom: 5px;

      .rectangle5-content-name {
        cursor: pointer;
        width: 100%;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .rectangle5-content-unit {
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
      }
    }

    .rectangle5-content-images {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 5px;

      .rectangle5-content-img {
        width: 67px;
        height: 75px;
      }
    }

    .rectangle5-content-size {
      width: 100%;
      font-weight: 700;
      text-align: center;
      font-size: 24px;
      height: 24px;
      color: rgba(0, 238, 255, 1);
    }
  }
}

/deep/.el-empty__description {
  p {
    color: #ffffff;
  }
}

.carouselBox {
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap; /* 自动换行 */
  justify-content: flex-start; /* 从左到右排列 */
  align-content: flex-start; /* 从上到下排列 */
  padding: 0 5%; /* 左右留一些边距，避免贴边 */
}

/deep/.el-carousel__container {
  height: 100%;
}
</style>
